<div class="breadcrumb-multiple" >
<map-breadcrumbs [breadCrumbs]="breadCrumbs"></map-breadcrumbs>
    <ng-container *ngFor="let link of accountLinks">
        <span [class.active]="link.component === this.componentName" [routerLink]="['../'+link.path]">{{link.name}}</span>
        <strong>|</strong>
    </ng-container>
</div>
